import classNames from 'classnames';
import { map } from 'lodash';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { autobudgetPriorityDictionary } from '../../service/PhrasesHelpers/PhrasesHelpers';
import { GdShowConditionAutobudgetPriority } from '../../typings/graphql-grid';
import { SelectDecorator } from '../SelectDecorator/SelectDecorator';

export interface EditableAutobudgetPriorityCellProps {
    id: string;
    groupId: string;
    autobudgetPriority?: GdShowConditionAutobudgetPriority;
    updatePhrase: (phrase: object) => void;
    columnName: string;
    cls?: string;
}

export class EditableAutobudgetPriorityCell extends React.Component<
    EditableAutobudgetPriorityCellProps
> {
    shouldComponentUpdate(nextProps: EditableAutobudgetPriorityCellProps) {
        return (
            nextProps.id !== this.props.id ||
            nextProps.groupId !== this.props.groupId ||
            nextProps.autobudgetPriority !== this.props.autobudgetPriority ||
            nextProps.cls !== this.props.cls ||
            nextProps.columnName !== this.props.columnName
        );
    }
    render() {
        const { cls } = this.props;

        return (
            <div
                className={classNames(
                    cls,
                    Bem.cls('editable-autobudget-priority-cell')
                )}
            >
                {this.getContent()}
            </div>
        );
    }

    private onChange = (value: string) => {
        const { id, groupId } = this.props;
        this.props.updatePhrase({
            id,
            groupId,
            autobudgetPriority: value
        });
    };

    private getContent() {
        const items = map(autobudgetPriorityDictionary, (value, key) => {
            return {
                text: value,
                val: key
            };
        });

        return (
            <SelectDecorator
                view={'classic'}
                type={'radio'}
                theme={'normal'}
                size={'xs'}
                onChange={this.onChange}
                items={items}
                val={this.props.autobudgetPriority}
            />
        );
    }
}
